// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonVideoPlayer_container__1eyE0","rmpButtonContainer":"SkeletonVideoPlayer_rmpButtonContainer__AvAHf"};